import { ApacCheckoutComponent, useApacCheckoutStyles } from "@apac/checkout";
import { useCardDisplay } from "@apac/components/checkout";
import type { CreditCard } from "@b2bportal/card-api";
import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { getCardIcon } from "@hopper-b2b/ui";
import defaultStyles from "./CardDisplay.module.scss";

export type CardDisplayProps = Pick<
  CreditCard,
  "last4" | "cardType" | "month" | "year" | "bin"
>;

export const CardDisplay = ({
  cardType,
  last4,
  month,
  year,
  bin,
}: CardDisplayProps) => {
  const { t } = useI18nContext();
  const styles = useApacCheckoutStyles(
    ApacCheckoutComponent.CardDisplay,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(styles, ApacCheckoutComponent.CardDisplay);

  const { getCardDisplayName, formatCardExpiry } = useCardDisplay();

  const cardName = getCardDisplayName(bin ?? "", cardType);
  const cardExpiry = formatCardExpiry({ month, year });

  return (
    <div className={block}>
      {getCardIcon(cardType, cn("icon"))}

      <div className={cn("text-container")}>
        <span className={cn("name")}>{cardName}</span>

        <span className={cn("card-number")}>
          {`${cardExpiry} ${last4 ? t("creditCardEndingText", { last4 }) : ""}`}
        </span>
      </div>
    </div>
  );
};
